import React, { useEffect, useState } from 'react';
import { resumoFinanceiro, fluxoCaixa } from '../../services/financeiroService';

export default function RelatorioFinanceiroPage() {
  const [resumo, setResumo] = useState(null);
  const [fluxo, setFluxo] = useState([]);
  const [periodo, setPeriodo] = useState({ de: '', ate: '' });

  useEffect(() => {
    resumoFinanceiro().then(res => setResumo(res.data.data));
  }, []);

  const buscarFluxo = async () => {
    if (periodo.de && periodo.ate) {
      const res = await fluxoCaixa(periodo);
      setFluxo(res.data.data);
    }
  };

  return (
    <div>
      <h2>Resumo Financeiro</h2>
      {resumo && (
        <ul>
          <li>Contas a Receber Pendentes: R$ {resumo.contas_receber_pendentes}</li>
          <li>Contas Recebidas: R$ {resumo.contas_recebidas}</li>
          <li>Contas a Pagar Pendentes: R$ {resumo.contas_pagar_pendentes}</li>
          <li>Contas Pagas: R$ {resumo.contas_pagas}</li>
        </ul>
      )}
      <h3>Fluxo de Caixa</h3>
      <div>
        <label>De: <input type="date" value={periodo.de} onChange={e => setPeriodo({ ...periodo, de: e.target.value })} /></label>
        <label>Até: <input type="date" value={periodo.ate} onChange={e => setPeriodo({ ...periodo, ate: e.target.value })} /></label>
        <button onClick={buscarFluxo}>Buscar</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Data</th>
            <th>Tipo</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          {fluxo.map((item, idx) => (
            <tr key={idx}>
              <td>{item.data}</td>
              <td>{item.tipo}</td>
              <td>{item.valor}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
